import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

export interface ToggleRailbarButtonProps {
  shouldShowChatRailbar: boolean;
  toggleChatRailbar: () => void;
}

export const ToggleRailbarButton = ({
  shouldShowChatRailbar,
  toggleChatRailbar,
}: ToggleRailbarButtonProps) => {
  const ariaLabel = shouldShowChatRailbar
    ? t("chat_space.header.collapse_railbar")
    : t("chat_space.header.expand_railbar");

  const iconType = shouldShowChatRailbar
    ? "rail-collapse-right"
    : "rail-collapse-left";

  return (
    <TippyV2 content={ariaLabel}>
      <IconButton
        onClick={toggleChatRailbar}
        ariaLabel={ariaLabel}
        className="rounded-lg"
        iconSize={20}
        buttonSize={36}
        name={iconType}
      />
    </TippyV2>
  );
};
